import { useMutation, useQueryClient } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";

export interface SelectAppleIAPAppsPayload {
  social_account_id: number;
  active_app_ids: string[];
}

interface SelectAppleIAPAppsResponse {
  message: string;
  active_apps: number;
  deactivated_apps: number;
}

export const useSelectAppleIAPApps = () => {
  const queryClient = useQueryClient();

  return useMutation<SelectAppleIAPAppsResponse, Error, SelectAppleIAPAppsPayload>({
    mutationFn: async (payload) => {
      return httpService.post<SelectAppleIAPAppsResponse, SelectAppleIAPAppsPayload>(
        API_CONFIG.path.appleIapSelectApps,
        payload,
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["integrations"] });
    },
  });
};
